import type { ReactNode } from "react";
import type { LeadCardLines } from "@shared/leadCard";
import { leadStatusTone } from "@web/lib/formatLeads";
import { statusTone } from "@web/lib/format";
import { Row } from "./Row";
import { ColorDot } from "./SelectChip";
import { StatusChip } from "./StatusChip";

/** A single three-line identity, shared by lead lists, record headers, Today and tours. */
export function LeadCard({ card, status, venueColor, onClick, trailing, actions, detail, eyebrow, identity = false }: {
  card: LeadCardLines; status: string; venueColor?: string | null; onClick?: () => void; trailing?: ReactNode;
  actions?: ReactNode; detail?: string; eyebrow?: string; identity?: boolean;
}) {
  return <Row className={`v365-lead-card v365-record-row${identity ? " v365-identity-row" : ""}`} wrap
    icon={identity ? undefined : <ColorDot color={venueColor} />}
    title={<>{eyebrow && <span className="v365-record-eyebrow">{eyebrow}</span>}<span>{card.line1}</span></>}
    subtitle={<>{card.line2 && <span className="v365-lead-event">{card.line2}</span>}<span className="v365-lead-meta">{card.line3}</span>{detail && <span className="v365-lead-detail">{detail}</span>}</>}
    trailing={trailing ?? <StatusChip tone={["pending", "contract_sent", "signed", "booked", "completed", "cancelled"].includes(status) ? statusTone(status) : leadStatusTone(status)}>{card.status}</StatusChip>}
    actions={actions} onClick={onClick} />;
}
